import { useAppSelector } from '@/src/store/hooks'
import { getTravelDetails } from '@/src/store/slices/visaSlice/travelDetailsSlice'
import { getVisaRequirementsState } from '@/src/store/slices/visaSlice/visaRequirementsSlice'
import { domainCountry } from '@/src/constants/domain'
import {
    nationalityList,
    travelDetailsList
} from '@/src/constants/visa/travelDetails'
import { getDisplayValue } from '@/src/utils/visa'

const useVisaHelperUtils = () => {
    const {
        isLoading,
        visaType,
        processingSpeed,
        dateOfArrival,
        paxDetails,
        fareRef
    } = useAppSelector(getVisaRequirementsState)
    const travelDetails = useAppSelector(getTravelDetails)

    const getCreateItineraryPayload = () => {
        if (!isLoading) {
            const { selectedOption } = visaType
            const { visaType: type = '', days } = selectedOption || {}
            const { destination, nationality } = travelDetails
            const { value: destinationCountryCode } = destination || {}
            const { value: nationalityCountryCode } = nationality || {}
            const { adults, children } = paxDetails
            const { type: processingSpeedType, paxFareTypeKeys } =
                processingSpeed || {}
            const fareRefKey = paxFareTypeKeys?.ADT || ''
            const { visaFareRefKey } = fareRef?.[fareRefKey] || ''
            const categoryType = processingSpeed?.categoryType || ''
            const nationalityCountryName = getDisplayValue(
                nationalityCountryCode,
                nationalityList
            )
            const destinationCountryName = getDisplayValue(
                destinationCountryCode,
                travelDetailsList
            )
            const payload = {
                visaParams: {
                    visaType: type,
                    categoryType: categoryType,
                    dateOfVisa: dateOfArrival,
                    visaFareRefKey: visaFareRefKey,
                    processingSpeed: processingSpeedType,
                    language: 'en',
                    days,
                    destinationCountryCode: destinationCountryCode,
                    nationalityCountryCode: nationalityCountryCode,
                    countryCode: destinationCountryCode,
                    domain: domainCountry,
                    nationality: nationalityCountryName,
                    destinationCountry: destinationCountryName
                },
                paxInfo: {
                    adult: adults,
                    child: children
                }
            }
            return payload
        }
        return {}
    }
    return {
        getCreateItineraryPayload
    }
}

export default useVisaHelperUtils
